<template>
    <header id="Header" class="relative z-[666]" :class="[css.container, dark && css.dark, dark && 'dark']">
        <div :class="css.main" class="relative z-[1] bg-white">
            <div class="container flex items-center h-[64px]">
                <!-- * Logo 容器 -->
                <div class="flex items-center">
                    <!-- * RDDC联盟 Logo -->
                    <ProjectRoute to="https://rddc.tsinghua-gd.org/rdgta/">
                        <img class="h-[36px] object-cover" :src="logos.website" alt="RDDC Website" />
                    </ProjectRoute>
                    <!-- * 分割线 -->
                    <div :class="css.division" class="w-[1px] h-[16px] mx-[16px] bg-default"></div>
                    <!-- * RDDC Logo -->
                    <ProjectRoute to="/" target="_self">
                        <img class="w-[149px] object-cover" :src="logos.rddc" alt="Logo" />
                    </ProjectRoute>
                </div>

                <!-- * 导航列表 -->
                <div class="flex-1 flex justify-end mr-[72px] max-xl:mr-[28px]">
                    <div :class="css.navigations" class="relative max-lg:first:hidden" v-for="(value, index) in vars.navigations" :key="index">
                        <!-- * 导航名称 -->
                        <div :class="[css.assets, classify.navigation]" class="h-[64px]" v-if="!value.route">{{ value.name }}</div>
                        <ProjectRoute :class="[css.assets, classify.navigation]" class="h-[64px]" target="_self" :to="value.route" v-else>
                            {{ value.name }}
                        </ProjectRoute>

                        <!-- * 子导航 -->
                        <div
                            :class="css.childrens"
                            class="absolute top-[100%] left-[50%] min-w-[100%] px-[16px] py-[12px] border border-solid border-uicolor4/15 bg-white rounded-[4px]"
                            v-if="value.routes">
                            <template v-for="(route, key) in value.routes" :key="key">
                                <ProjectRoute class="block whitespace-nowrap hover:underline" target="_self" :to="route.route">
                                    {{ route.name }}
                                </ProjectRoute>
                            </template>
                        </div>
                    </div>
                </div>

                <!-- * 搜索组件 -->
                <SearchControl class="module-search" />

                <!-- * 用户模块 -->
                <div class="flex-center mr-[16px]">
                    <!-- * 登录按钮 -->
                    <ui-icon
                        :class="css.user"
                        class="p-[8px] text-[32px] rounded-[4px] cursor-pointer transition-all duration-500 hover:bg-[#f4f4f4] hover:text-main"
                        name="account"
                        @click="methods.login"
                        v-if="!user.id" />

                    <!-- * 用户头像 -->
                    <ProjectRoute class="flex-center" :to="{ name: 'UserLayout' }" v-else>
                        <img class="w-[32px] h-[32px] rounded-[50%] object-cover" :src="user.avatar" alt="User Avatar" />
                    </ProjectRoute>
                </div>

                <!-- * 语言控制器 -->
                <div class="flex items-center text-[16px]">
                    <ProjectRoute :class="css.assets" :to="routes.zh" language="zh" target="_parent">中文</ProjectRoute>
                    <div :class="css.division" class="w-[1px] h-[12px] mx-[12px] bg-default"></div>
                    <ProjectRoute :class="css.assets" :to="routes.en" language="en" target="_parent">EN</ProjectRoute>
                </div>
            </div>
        </div>
    </header>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";
//* 私有组件
import SearchControl from "./components/search-control/index.vue";
//* 组件属性
import { ComponentPropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./index.module.less";

//* 组件属性注册
const define = defineProps(ComponentPropsOption);
//* 持久化数据注册
const user = useUserStore();

//* 组合函数
const { vars, classify, computeds, methods } = useComposable(define);
const { logos, routes } = computeds;
</script>
